import { isArray, isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

import { StyledWrapper } from './Slider.styles';
import { ISliderProps } from './Slider.types';
import { useSlider } from './SliderContext';
import SliderDots from './SliderDots';
// import SliderDotsListing from './SliderDotsListing';
import SliderNav from './SliderNav';
// import SliderNavListing from './SliderNavListing';
import SliderProgressBar from './SliderProgressBar';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const Slider = ({
  autoplay = true,
  autoplayInterval,
  animateTransitions = false,
  children,
  containerStyle,
  enableMouseEvents = false,
  hasNav,
  hasNavListing,
  hasDots,
  hasDotsListing,
  hasProgressBar,
  slideStyle,
  user = 'landlord',
  onSlideChange,
}: ISliderProps): JSX.Element => {
  const { index, setIndex, setData, data } = useSlider();

  useEffect(() => {
    if (children && isArray(children) && isEmpty(data)) {
      setData(children.map(child => child?.props));
    }
  }, [children, data, setData]);

  useEffect(() => {
    onSlideChange && onSlideChange(data, index);
  }, [index, data, onSlideChange]);

  return (
    <StyledWrapper>
      {hasNav && <SliderNav />}
      {hasNavListing && <SliderNav listing />}

      <AutoPlaySwipeableViews
        enableMouseEvents={enableMouseEvents}
        containerStyle={containerStyle}
        animateTransitions={animateTransitions}
        slideStyle={slideStyle}
        index={index}
        interval={autoplayInterval}
        autoplay={autoplay}
        onChangeIndex={(newIndex: number) => {
          setIndex(newIndex);
        }}
      >
        {children}
      </AutoPlaySwipeableViews>

      {hasDots && <SliderDots user={user} />}
      {hasDotsListing && <SliderDots listing />}

      {autoplay && autoplayInterval && hasProgressBar && (
        <SliderProgressBar interval={autoplayInterval} />
      )}
    </StyledWrapper>
  );
};

export default Slider;
